import React, { useState } from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";

import * as Yup from "yup";

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  IconButton,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  selectClasses,
  TextField,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import {
  SCSGenericButton,
  SCSLoadingButton,
} from "app/modules/common/components/Buttons/SCSButtons";

import { StyleInputs } from "app/modules/common/styles/themes";

import { MaskCelulares } from "app/modules/shared/mask/mascarasInputs";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    minWidth: 450,
    height: 300,
  },
  "& .MuiDialogContent-root": {
    padding: theme.spacing(3),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const ModalEnvioLinkOtros = ({
  open,
  setOpen,
  loading,
  handleSendByMail,
  handleSendByWhatsApp,
}) => {
  const handleSendUrl = (values) => {
    if (values.medioEnvio === "email") {
      handleSendByMail(values.contacto);
    } else {
      handleSendByWhatsApp(values.contacto);
    }
  };
  return (
    <BootstrapDialog
      onClose={() => setOpen(false)}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={() => setOpen(false)}
      >
        Envio Url
      </BootstrapDialogTitle>

      <DialogContent dividers>
        <Formik
          initialValues={{ contacto: "", medioEnvio: "" }}
          enableReinitialize={true}
          validationSchema={Yup.object({
            medioEnvio: Yup.string().required("Tipo requerido"),
            contacto: Yup.string().required("Contacto requerido"),
          })}
          onSubmit={(values, { setSubmitting }) => {
            handleSendUrl(values);
          }}
        >
          {({ values, handleChange, touched, errors, handleBlur }) => (
            <Form>
              <div className="cliente-informacion-seccion">
                <FormControl
                  sx={{ width: "35%" }}
                  error={touched.medioEnvio && Boolean(errors.medioEnvio)}
                  helperText={touched.medioEnvio && errors.medioEnvio}
                  onBlur={handleBlur}
                  size="small"
                >
                  <InputLabel id="medioEnvio ">Medio</InputLabel>
                  <Field name="medioEnvio" label="Local" as={Select}>
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    <MenuItem value="email">EMAIL</MenuItem>
                    <MenuItem value="whatsapp">WHATSAPP</MenuItem>
                  </Field>
                  <ErrorMessage
                    name="medioEnvio"
                    component={() => (
                      <FormHelperText>{errors.medioEnvio}</FormHelperText>
                    )}
                  />
                </FormControl>

                {values.medioEnvio === "email" && (
                  <TextField
                    id="contacto"
                    name="contacto"
                    type="text"
                    label="Email"
                    sx={StyleInputs(55, 95)}
                    value={values.contacto}
                    onChange={handleChange}
                    size="small"
                    error={touched.contacto && Boolean(errors.contacto)}
                    helperText={touched.contacto && errors.contacto}
                    onBlur={handleBlur}
                  />
                )}

                {values.medioEnvio === "whatsapp" && (
                  <FormControl
                    sx={StyleInputs(55, 45)}
                    size="small"
                    variant="outlined"
                    error={touched.contacto && Boolean(errors.contacto)}
                    helperText={touched.contacto && errors.contacto}
                    onBlur={handleBlur}
                  >
                    <InputLabel htmlFor="contacto">Celular</InputLabel>
                    <OutlinedInput
                      value={values.contacto}
                      onChange={handleChange}
                      name="contacto"
                      id="contacto"
                      inputComponent={MaskCelulares}
                      label="Contacto"
                    />
                    <ErrorMessage
                      name="contacto"
                      component={() => (
                        <FormHelperText>{errors.contacto}</FormHelperText>
                      )}
                    />
                  </FormControl>
                )}
              </div>

              <section style={{ marginTop: "1rem" }}>
                <SCSLoadingButton
                  type="submit"
                  size={35}
                  titulo="enviar"
                  /* loading={loading} */
                />
              </section>
            </Form>
          )}
        </Formik>
      </DialogContent>

      <DialogActions>
        <SCSLoadingButton
          size={35}
          titulo="Cancelar"
          onClick={() => setOpen(false)}
        />
      </DialogActions>
    </BootstrapDialog>
  );
};

export default ModalEnvioLinkOtros;
